import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [hasPreviewContent, setPreviewContent] = useState(''); 
    const [logoutTimer, setLogoutTimer] = useState(null);
 
    const login = ({token}) => {

      const expiryTime = Date.now() + 59 * 60 * 1000; // 30 minutes from now


        Object.keys(localStorage).forEach(key => {
           
            if (key.startsWith('cache-')) {
             
              localStorage.removeItem(key);
            }
          });
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("expiryTime", expiryTime);

        setIsLoggedIn(true);
        // Set auto-logout timer based on 29 minutes
        const timer = setTimeout(() => {
          logout();
      }, 29 * 60 * 1000);
      setLogoutTimer(timer);

    };

    const logout = () => {
    
 localStorage.removeItem("abmSelectedMonth");
  localStorage.removeItem("abmSelectedYear");

        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("token");
         localStorage.removeItem("masterToken");
        localStorage.removeItem("expiryTime");
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('cache-')) {
              localStorage.removeItem(key);
            }
          });
        setIsLoggedIn(false);
        if (logoutTimer) {
          clearTimeout(logoutTimer);
          setLogoutTimer(null);
      }
          window.location.href = "/login";

    };
  
 
    const setPreview = (imageSource) =>{
      console.log(imageSource);
      setPreviewContent(imageSource);
    }

    useEffect(() => {
        
        const userLoggedIn = localStorage.getItem("isLoggedIn") === "true";
        const expiryTime = localStorage.getItem("expiryTime");

        setIsLoggedIn(userLoggedIn);

        if (userLoggedIn && expiryTime) {
          const currentTime = Date.now();
          const timeRemaining = expiryTime - currentTime;

          if (timeRemaining > 0) {
              setIsLoggedIn(true);

              // Set auto-logout timer for the remaining time
              const timer = setTimeout(() => {
                  logout();
              }, timeRemaining - 60 * 1000); // Auto-logout 1 minute before expiry (i.e., 29 minutes)
              setLogoutTimer(timer);
          } else {
              // Token has expired, log the user out
              logout();
          }
      }

    }, []);

    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout, hasPreviewContent, setPreview }}>
            {children}
        </AuthContext.Provider>
    );
};
